// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".main-svg {\n  width: 100% !important;\n}", "",{"version":3,"sources":["webpack://src/views/individual-reports/individual-reports.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;AACF","sourcesContent":[".main-svg {\n  width: 100% !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
